import { IParamsCourseObject } from '@/courses/interfaces/params-course-object.interface';
import { IParamsCreateFileObject } from '@/courses/interfaces/params-create-file-object.interface';
import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import EdCreateOtherFilesObject from '../ed-create-other-files-object/ed-create-other-files-object.vue';
import KEYS from '@/values/keys';
import { IResultCreateFileObject } from '@/courses/interfaces/result-create-file-object.interface';
import { SECTION_TYPES } from '@/content/values/sections';
import { CreateObjectsMixin } from '@/courses/mixins/create-objects.mixin';

@Component({
  components: {
    EdCreateOtherFilesObject
  }
})
export default class EdCourseCreateOtherFilesObject extends Mixins(CreateObjectsMixin) {

  // @Prop() readonly params: IParamsCourseObject;     //Typescript upgrade
  declare readonly params: IParamsCourseObject;

  public createParams: IParamsCreateFileObject = {
    edition: false,
    homework: { show: false },
    grade: { show: false },
    labelSections: '',
  }; 
  public loaded: boolean = false;
  public fileComponent: any = null;

  get courseId() {
    return this.params.courseId;
  }

  get classId() {
    return this.params.classId;
  }

  get parentId() {
    return this.params.parentId;
  }

  get section() {
    return this.params.section;
  }

  onSave(fileObject: IResultCreateFileObject) {
    this.fileComponent = this.$refs.EdCreateOtherFilesObject;
    this.fileComponent.setSaving(true);
    if(this.params.edition) {
      this.updateFile(fileObject);
      return;
    }
    this.saveFile(fileObject);
  }

  async updateFile(fileObject: IResultCreateFileObject) {
    try {
      let req: any = { 
        name: fileObject.name,
        type: fileObject.type,
        sectionId: this.section.sectionId,
        homework: fileObject.homework,
        teacherOnly: this.section.teacherOnly,
        text: '',
        courseId: this.courseId,
        labelSections: fileObject.labelSections,
        component: fileObject.component
      };
      if(fileObject.fileAdded) {
        /* The previous file is removed */
        if(this.section && this.section.text) {
          await this.$Courses.Store.removeFileA(this.section);
        }
        
        /* The new file is added */
        await this.$Courses.Store.updateFileA({
          file: fileObject.file,
          sectionId: this.section.sectionId,
          courseId: this.courseId,
          sectionType: SECTION_TYPES.LESSON_OTHER_FILE.code
        });
      }
      /* The data is updated */
      let refreshData = {
        sectionId: this.section.sectionId,
        parentId: this.parentId, 
        courseId: this.courseId,
        classId: this.classId
      };
      await this.$Courses.Store.updateSectionA(req);
      await this.goToRefreshSectionsTree(refreshData);
      this.fileComponent.setSaving(false);
      this.onClose();
    } catch(err) {
      this.fileComponent.setSaving(false);
      this.onUploadEpubError(err);
    }
  }

  saveFile(fileObject: IResultCreateFileObject) {
    this.createObject({
      type: SECTION_TYPES.LESSON_OTHER_FILE.code,
      name: fileObject.name,
      file: fileObject.file,
      homework: fileObject.homework,
      parentId: this.parentId,
      courseId: this.params.courseId,
      classId: this.params.classId,
      labelSections: fileObject.labelSections,
      component: fileObject.component
    })
    .then(() => { this.onClose(); })
    .catch((error) => {
      this.onUploadEpubError(error);
    })
    .finally(() => {
      this.fileComponent.setSaving(false);
    });
  }

  onClose() {
    this.$EdModal.closeModal();
  }

  created() {
    if(this.params.edition) {
      let dates = this.section.submissionDates || {}; 
      let filename = this.section.assetsInfo[0].fileName.split('.');
      this.createParams.edition = true;
      this.createParams.homework.value = this.section.homework;
      this.createParams.type = this.section.type;
      this.createParams.ext = filename[filename.length - 1];
      this.createParams.name = this.section.name;
      this.createParams.text = this.section.text;
      this.createParams.title = String(this.$i18n.t('lesson.editFileTitle'));
      this.createParams.file = { name: this.section.name };
      this.createParams.dueDate = this.getSchoolDayDate(dates.dueSchoolDay);
      this.createParams.labelSections = this.section.labelSections;
      this.createParams.component = this.section.component;
    } else {
      this.createParams.title = String(this.$i18n.t('courses.objects.createFile'));
    }
    if(this.params.preload) {
      let filename: string = this.params.preload.file.name;
      let file = filename.split('.');
      let ext = file[file.length-1];
      this.createParams.edition = false;
      this.createParams.preload = true;
      this.createParams.name = filename.replace(`.${ext}`, '');
      this.createParams.homework.value = false;
      this.createParams.file = this.params.preload.file;
      this.createParams.ext = ext;
    }

    this.createParams.hasTagSelector = this.params.contentType === 'TEMPLATE';
    this.createParams.courseId = this.params.courseId;
    this.createParams.minDate = this.params.minDate;
    this.loaded = true;
  }

  onUploadEpubError(error) {
    this.fileComponent = this.$refs.EdCreateOtherFilesObject;
    this.fileComponent.removeFile();
    if(error.data && error.data.status === 400 && error.data.errors) {
      let errors = error.data.errors[0];
      let message = String(this.$i18n.t(`courses.errors.codes.${errors.status}`));
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('courses.errors.errorTitle'),
        body: message,
        type: KEYS.EVENT_TYPES.DANGER
      });
    } else {
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('courses.errors.errorTitle'),
        body: this.$i18n.t('courses.errors.errorSavingObject'),
        type: KEYS.EVENT_TYPES.DANGER
      });
    }
  }

}